import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { studentNotificationModel } from 'common/models/page-models/Student Notification/student-assignment-data-model';
import { studentNotificationListingModel } from 'common/models/page-models/Student Notification/student-notification-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { studentNotificationGridWidgetService } from 'common/widget/Student Notification/student-notification-grid-widget.service';



 
@Injectable({
    providedIn: 'root'
})
export class studentNotificationGridResolver extends GridResolver<studentNotificationModel, studentNotificationListingModel> {
    constructor(
        protected fs: studentNotificationGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
       
    }

    
}